import { useState } from "react";

import { EmvGlobalConfigurationEditForm } from "src/app/features/EmvGlobalConfiguration/components/forms/EmvGlobalConfigurationEditForm";
import { useEmvGlobalConfigurationLoadQuery } from "src/app/features/EmvGlobalConfiguration/services/server/EmvGlobalConfigurationApi";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const EmvGlobalConfigurationEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.EMV_GLOBAL_CONFIGURATIONS, "canWrite");
    const hasAccess = canAccess(ResourceName.EMV_GLOBAL_CONFIGURATIONS, "canRead");
    const { data: entity } = useEmvGlobalConfigurationLoadQuery();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = entity?.id
        ? `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/emv-global-config/${entity.id}/${FORM_ACTION.HISTORY}`
        : undefined;

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.emvGlobalConfigurationsEditFormPage" />
                        {hasWriteAccess && (
                            <ActionBar>
                                <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                                <HistoryButton url={historyUrl} />
                                <RefreshButton isDisabled={false} />
                            </ActionBar>
                        )}
                    </FPageHeader>
                    <FPageContent>
                        <EmvGlobalConfigurationEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
